import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    outline: "text-outline-teal",
    title: "Play fair",
    body: "Rules apply to grown-ups too. Hidden answers, locked turns, one timer for everyone. The app is the referee so nobody else has to be.",
  },
  {
    n: "02",
    outline: "text-outline-yellow",
    title: "Play together",
    body: "One phone, whole couch. Questions a six-year-old can answer next to ones that stump the adults – in the same round, on purpose.",
  },
  {
    n: "03",
    outline: "text-outline-coral",
    title: "Play anywhere",
    body: "Offline packs for road trips, flights, and rainy cabins. No accounts, no ads, no 'just one more permission'.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="border-y-2 border-[#1A1D1E] bg-[#1A1D1E] text-[#FAF9F6]">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 py-24 md:px-12 md:py-32 lg:grid-cols-2">
      <div className="lg:sticky lg:top-32 lg:self-start">
        <Reveal>
          <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-[#FFC837]">
            The TriviaPro manifesto
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold tracking-tight md:text-5xl">
            Three rules we
            <br />
            never break.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative mt-10">
            <div className="absolute -inset-3 rounded-[24px] bg-[#1FBCA2]/30 blur-2xl" aria-hidden="true" />
            <img
              src="https://images.unsplash.com/photo-1458546450666-ebb1e605853f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxraWRzJTIwbGF1Z2hpbmclMjBwaG9uZXxlbnwwfHx8fDE3ODkzOTQ3NDV8MA&ixlib=rb-4.1.0&q=85"
              alt="Kids laughing together while looking at a phone"
              loading="lazy"
              className="relative w-full -rotate-2 rounded-[20px] border-2 border-[#FAF9F6] object-cover shadow-[0_10px_0_0_#1FBCA2]"
            />
          </div>
        </Reveal>
      </div>

      <div className="flex flex-col gap-14">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <article data-testid={`manifesto-chapter-${c.n}`} className="relative">
              <span
                aria-hidden="true"
                className={`pointer-events-none absolute -top-10 -left-2 select-none font-display text-8xl font-bold md:text-9xl ${c.outline}`}
              >
                {c.n}
              </span>
              <div className="relative pt-12">
                <h3 className="font-display text-2xl font-semibold md:text-3xl">{c.title}</h3>
                <p className="mt-3 max-w-md leading-relaxed text-[#FAF9F6]/65">{c.body}</p>
              </div>
              {i < CHAPTERS.length - 1 && (
                <div className="mt-14 h-0.5 w-full bg-[#FAF9F6]/10" aria-hidden="true" />
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
